// request.js

import axios from 'axios';

const instance = axios.create({
  baseURL: "https://ht.wteam.club/api",
  timeout: 50000,
  headers: {
    'Content-Type': 'application/json',
  },
});

//收银机图片接口
const instance2 = axios.create({
  baseURL: "https://ht.wteam.club/device",
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // 假设你的 token 存储在本地存储中
    const storeId = localStorage.getItem('storeId'); // 假设你的 token 存储在本地存储中

    // 如果有 token，将其添加到请求头
    if (token) {
      config.headers['token'] = `${token}`;      
    }
    if (storeId) {      
      config.headers['storeid'] = `${storeId}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 收银机接口添加请求拦截器
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token'); // 假设你的 token 存储在本地存储中

    // 如果有 token，将其添加到请求头
    if (token) {
      config.headers['token'] = `${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export function get(url, params = {}) {
  return instance
    .get(url, {
      params: params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}

export function post(url, data = {}) {
  return instance
    .post(url, data)
    .then((response) => {
      console.log("----------")
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
}




// WEBPACK FOOTER //
// ./src/api/request.js